module.exports = {
  messages: {
    CN: {
      pageDesc: '表单页用于向用户收集或验证信息，基础表单常见于数据项较少的表单场景。',
      title: '标题',
      titleInput: '给目标起个名字',
      date: '起止日期',
      describe: '目标描述',
      describeInput: '请输入你阶段性工作目标',
      metrics: '衡量标准',
      metricsInput: '请输入衡量标准',
      customer: '客户',
      customerInput: '请描述你服务的客户，内部客户直接 @姓名／工号',
      critics: '邀评人',
      criticsInput: '请直接 @姓名／工号，最多可邀请 5 人',
      weight: '权重',
      disclosure: '目标公开',
      disclosureDesc: '客户、邀评人默认被分享',
      public: '公开',
      partially: '部分公开',
      private: '不公开',
      submit: '提交',
      save: '保存',
      colleague1: '同事甲',
      colleague2: '同事乙',
      colleague3: '同事丙'
    },
    HK: {
      pageDesc: '表單頁用於向用戶收集或驗證信息，基礎表單常見於數據項較少的表單場景。',
      title: '標題',
      titleInput: '給目標起個名字',
      date: '起止日期',
      describe: '目標描述',
      describeInput: '請輸入你階段性的工作目標',
      metrics: '衡量標準',
      metricsInput: '請輸入衡量標準',
      customer: '客戶',
      customerInput: '請描述你服務的客戶，內部客戶直接 @姓名／工號',
      critics: '邀評人',
      criticsInput: '請直接 @姓名／工號，最多可邀請 5 人',
      weight: '圈中人',
      disclosure: '目標公開',
      disclosureDesc: '客戶、邀評人默認被分享',
      public: '公開',
      partially: '部分公開',
      private: '不公開',
      submit: '提交',
      save: '保存',
      colleague1: '同事甲',
      colleague2: '同事乙',
      colleague3: '同事丙'
    },
    US: {
      pageDesc: 'Form pages are used to collect or verify information to users, and basic forms are common in scenarios where there are fewer data items.',
      title: 'Title',
      titleInput: 'Give the target a name',
      date: 'Start and end date',
      describe: 'Goal description',
      describeInput: 'Please enter your work goals',
      metrics: 'Metrics',
      metricsInput: 'Please enter a metric',
      customer: 'Customer',
      customerInput: 'Please describe your customer service, internal customers directly @ Name / job number',
      critics: 'Inviting critics',
      criticsInput: 'Please direct @ Name / job number, you can invite up to 5 people',
      weight: 'Weight',
      disclosure: 'Target disclosure',
      disclosureDesc: 'Customers and invitees are shared by default',
      public: 'Public',
      partially: 'Partially public',
      private: 'Private',
      submit: 'Submit',
      save: 'Save',
      colleague1: 'Colleague A',
      colleague2: 'Colleague B',
      colleague3: 'Colleague C'
    }
  }
}
